export default __webpack_public_path__ + "static/media/Chicken.f654a11f.jpg";